import { render } from "./StatusTab.vue?vue&type=template&id=60154e28&scoped=true&ts=true"
import script from "./StatusTab.vue?vue&type=script&lang=ts"
export * from "./StatusTab.vue?vue&type=script&lang=ts"

import "./StatusTab.vue?vue&type=style&index=0&id=60154e28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60154e28"]])

export default __exports__